import httpManager from "@/app/shared/utils/httpManager";
import { TABLE_PAGE_SIZE } from "@/app/shared/utils/constants";
/**
 * Obtener el resultado de los usuarios
 *
 * @param {string} search Identificador para la busqueda de un usuario
 *  @param {string} profile Identificador del rol del usuario.
 * @param {Object} pagination Datos de la paginación.
 * @return {Promise<Array>} Listado de usuarios
 *
 */

export async function fetchAllFilterProfile(profile = "", search = "", pagination = {}) {
  profile = profile == 0 ? "" : profile;
  const offset = (pagination.current - 1 || 0) * TABLE_PAGE_SIZE;
  const pageSize = pagination.pageSize || TABLE_PAGE_SIZE;
  const url = `/users/?profile=${profile}&search=${search}&offset=${offset}&limit=${pageSize}`;
  const response = await httpManager.get(url);
  return response?.data;
}
